import React, { useEffect, useState } from "react";
import AllDropDownsAHSF from "../../../Components/AllDropDownsAHSF";
import { useDispatch, useSelector } from "react-redux";
import { GetAllRoundActive } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllRoundActive";
import { GetAllFieldsManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFieldsManager";
import { GetAllSubjectManager } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllSubjectManager";
import { GetAllFlow } from "../../../Redux/Reducers/Manager/Dropdowns/GetAllFlow";
import InputAHSF from "../../../Components/InputAHSF";
import { GetFilteredTasksCount } from "../../../Redux/Reducers/Manager/Tasks";
import SharedDiv from "../../../Components/SharedDiv/SharedDiv";
import TableAHSF from "../../../Components/TableAHSF";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { GetCurrentFlow } from "../../../Redux/Reducers/Manager/Dropdowns/GetCurrentFlow";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

const Tasks = (props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const RoundList = useSelector((state) => state.AllRoundActive.AllRoundActive);
  const FieldsList = useSelector(
    (state) => state.AllFieldsManager.AllFieldsManager
  );
  const SubjectList = useSelector(
    (state) => state.AllSubjectManager.AllSubjectManager
  );
  const FlowList = useSelector((state) => state.AllCurrentFlow.AllCurrentFlow);
  const TasksCount = useSelector((state) => state.Tasks.TasksCount);

  const [roundId, setRoundId] = useState(null);
  const [FieldId, setFieldId] = useState(null);
  const [SubjectId, setSubjectId] = useState(null);
  const [actionId, setActionId] = useState(null);
  const [flowId, setflowId] = useState(null);
  const [count, setCount] = useState(TasksCount);

  const [validateList, setvalidateList] = useState([]);
  const [btnLoading, setBtnLoading] = useState(false);

  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks?.arrayDataCheckBoks["tasksList"]
  );

  console.log(arrayDataCheckBoks, "arrayDataCheckBoks");

  useEffect(() => {
    dispatch(GetAllRoundActive());

    dispatch(GetCurrentFlow());
  }, []);

  useEffect(() => {
    dispatch(GetAllFieldsManager({ roundYearId: roundId }));
  }, [roundId]);
  useEffect(() => {
    dispatch(GetAllSubjectManager({ fieldId: FieldId }));
  }, [FieldId]);
  const getCount = async () => {
    if (roundId && FieldId && SubjectId && actionId) {
      const countData = await dispatch(
        GetFilteredTasksCount({
          roundYearId: roundId,
          fieldId: FieldId,
          subjectId: SubjectId,
          flowId: flowId,
        })
      );
      if (countData.payload) {
        setCount(countData.payload);
      } else {
        setCount(0);
      }
      dispatch(setRefreshTable({ tableId: "tableTask" }));
    } else {
      setCount(0);
    }
  };

  useEffect(() => {
    getCount();
  }, [roundId, FieldId, SubjectId, actionId]);

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الطلب",
      NmaeColumnEN: "Application Number",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fullName",
      ShowStatus: true,
      NmaeColumn: " الاسم الكامل",
      NmaeColumnEN: "Status",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: " الحقل",
      NmaeColumnEN: "Round Year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subjectName",
      ShowStatus: true,
      NmaeColumn: "الموضوع",
      NmaeColumnEN: "Round Year",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "taskStatusName",
      ShowStatus: true,
      NmaeColumn: "حالة المهمة",
      NmaeColumnEN: "Task Status",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "subTasksdata",
      ShowStatus: true,
      NmaeColumn: "المهام الفرعية",
      NmaeColumnEN: "Sub Tasks",
      TotalNumber: false,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      customRender: (subTasksdata, row) => {
        if (!row.containsSubTasks || !subTasksdata || subTasksdata.length === 0) {
          return <span className="subtasks-empty">—</span>;
        }
        const labelsByFlow = {
          "026c6b5a-2be1-4092-85f6-b396690789cf": {
            actionName: "الاجراء",
            additionalNote: "ملاحظات",
          },
          "a9cad6cd-6a42-4397-81e5-4e888fcc2f3c": {
            actionName: "قاشمة قصيرة",
            additionalNote: "ملاحظات",
          },
        };
        const defaultLabels = { actionName: "الاجراء", additionalNote: "ملاحظات" };

        const grouped = subTasksdata.reduce((acc, task) => {
          const key = task.flowName || "أخرى";
          if (!acc[key]) acc[key] = [];
          acc[key].push(task);
          return acc;
        }, {});

        return (
          <div className="subtasks-list">
            {Object.entries(grouped).map(([flowName, tasks], gi) => (
              <div key={gi} className="subtask-group">
                <div className="subtask-group-header">{flowName}</div>
                {tasks.map((task, i) => {
                  const labels = labelsByFlow[task.flowId] || defaultLabels;
                  return (
                    <div key={i} className="subtask-item">
                      <span className="subtask-avatar">
                        {task.userNAme?.charAt(0)?.toUpperCase()}
                      </span>
                      <div className="subtask-info">
                        <span className="subtask-username">{task.userNAme}</span>
                        <span className="subtask-action">
                          <strong>{labels.actionName}: </strong>
                          {task.actionName || "—"}
                        </span>
                        <span className="subtask-note">
                          <strong>{labels.additionalNote}: </strong>
                          {task.additionalNote || "—"}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}
          </div>
        );
      },
    },
  ];

  const OtherMainBtns = [
    {
      Click: async (e) => {
        const result = JSON.parse(e.target.value)?.applicationInformationId;

        console.log(result, "sssswdwdwffefssssdwdwdwdwd");
        window.open(
          `/ResearchersAward/manager/ViewApplication/ApplicationInformation/` +
            result,
          "_blank"
        );
      },
      content: "",
      className: "bi bi-view-list",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    
  ];
  const RequestsColumns = [];
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: <div></div>,
    maxWidth: "700px",
    maxHeight: "600px",
  };

  const validation = async () => {
    const validationMassage = [];

    if (!roundId) validationMassage.push("الدورة");
    if (!FieldId) validationMassage.push("الحقل");
    if (!SubjectId) validationMassage.push("الموضوع");
    if (!actionId) validationMassage.push("الحالة الحالية للطلبات");
    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      validationMassage.push("الرجاء اختيار طلب واحد على الاقل");

    if (validationMassage.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء تعبئة الحقول التالية",
        html: `
          <div style="text-align: right; direction: rtl; font-size: 16px;">
            <ul style="list-style-type: none; padding: 0;">
              ${validationMassage
                .map(
                  (field) =>
                    `<li style="margin-bottom: 8px;">🔸 <strong>${field}</strong></li>`
                )
                .join("")}
            </ul>
          </div>
        `,
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }
    setBtnLoading(true);
    navigate(
      `/ResearchersAward/manager/ActionOnApplications/${actionId}/${flowId}/${roundId}/${FieldId}/${SubjectId}`
    );
    setCount(0);
    setBtnLoading(false);
  };

  return (
    <>
      <SharedDiv
        showTitle={true}
        titleNameEN="Application Information"
        titleNameAR="معلومات الطلب"
        lang={"ar"}
        titleName="معلومات الطلب"
        child={[
          <div className="form-grid">
            <AllDropDownsAHSF
              fieldsName="Round"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={RoundList}
              KeyText={"roundNameAr"}
              KeyValue={"roundYearId"}
              //   value={applicantInfo?.gender}
              onChange={(e) => {
                setRoundId(e.target.value);
                setFieldId(null);
                setSubjectId(null);
                setActionId(null);
                dispatch(SetArrayDataCheckBoks());
              }}
              showValidationMessage={validateList?.includes("roundId")}
              validationMessage={"حقل اجباري"}
            />
            <AllDropDownsAHSF
              fieldsName="field"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={FieldsList}
              KeyText={"fieldNameAr"}
              KeyValue={"fieldId"}
              value={FieldId}
              onChange={(e) => {
                setFieldId(e.target.value);
                setSubjectId(null);
                dispatch(SetArrayDataCheckBoks());
              }}
              showValidationMessage={validateList?.includes("FieldId")}
              validationMessage={"حقل اجباري"}
            />
            <AllDropDownsAHSF
              fieldsName="topic"
              lang={"ar"}
              show={true}
              disabled={props.disabled}
              yesNo={true}
              dropdownType="normal"
              arrayOoptionList={SubjectList}
              KeyText={"subjectNameAr"}
              KeyValue={"subjectId"}
              value={SubjectId}
              onChange={(e) => {
                setSubjectId(e.target.value);
                dispatch(SetArrayDataCheckBoks());
              }}
              showValidationMessage={validateList?.includes("SubjectId")}
              validationMessage={"حقل اجباري"}
            />

            <AllDropDownsAHSF
              fieldsName="CurrentStatusOfRequests"
              hidelable={false}
              disabled={props.disabled}
              lang={"ar"}
              show={true}
              submissionStatus={"edite"}
              arrayOoptionList={FlowList}
              KeyText={"actionName"}
              id={"actionId"}
              dropdownType={"search"}
              value={actionId}
              OnClickLi={(e) => {
                setActionId(e.actionId);
                setflowId(e.flowId);
                dispatch(SetArrayDataCheckBoks());
              }}
              showValidationMessage={validateList?.includes("actionId")}
              validationMessage={"حقل اجباري"}
            />
            <div style={{ marginTop:"5px" }}>
              <InputAHSF
                fieldsName="NumberOfRequests"
                show={true}
                lang={"ar"}
                disabled={true}
                value={count}
              />
            </div>
          </div>,
        ]}
      />

      <TableAHSF
        tableId="tableTask"
        culomEdite={culomEdite}
        lang={"ar"}
        uniqueValue={""}
        valueButtonAction={""}
        URL={`api/Tasks/GetFilteredTasks`}
        UrlBody={{
          roundYearId: roundId,
          fieldId: FieldId,
          subjectId: SubjectId,
          flowId: flowId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"المهام"}
        titelTableEN={"المهام"}
        selectRowNumber={true}
        checkBoksColumName="تحديد الكل"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        hideIconsAction={true}
        checkBoks={true}
        uniqeKeyNameRedux={"tasksList"}
        uniqeKeyName={"taskId"}
        nameColumAction=""
        showIconsApplication={true}
        total={false}
        arrayButton={OtherMainBtns}
        checkBoksCustomRender={true}
        checkBoksCustomRenderKeyName={"taskStatus"}
        checkBoksCustomRenderKeyValue={[
          "74eca88d-0097-400d-a570-fe81598f8ce3",
         
        ]}
        checkBoksCustomRenderShowOrHide={false}
        ArrayNameDataColum={RequestsColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
      />

      <div className="containerButtonMAin">
        <ButtonAHSF
          type={"submitter"}
          fieldsName="TakeAction"
          lang={"ar"}
          text={"اخذ اجراء"}
          onClick={validation}
          disabled={false}
          loading={btnLoading}
          title={"اخذ اجراء"}
          show={true}
        />
      </div>
    </>
  );
};

export default Tasks;
